import gql from 'graphql-tag';

const REPROCESS_STATUS_SUBSCRIPTION = gql`
  subscription reprocessStatus($where: ReprocessStatusSubscriptionWhereInput!) {
    reprocessStatus(where: $where) {
      node {
        id
        key
        module
        dateQueued
        dateProcessed
        dateFinished
        status
      }
    }
  }
`;

export default REPROCESS_STATUS_SUBSCRIPTION;
